"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var input_base_component_1 = require("../input-base/input-base.component");
var polyfills_1 = require("./polyfills");
polyfills_1.processPolyfills();
var SelectPickerComponent = (function (_super) {
    __extends(SelectPickerComponent, _super);
    function SelectPickerComponent(el) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        _this.multiple = false;
        _this.autofocus = false;
        _this.noneSelectedText = 'Nothing selected';
        _this.noneResultsText = 'No results matched ';
        _this.multipleSeparator = ', ';
        _this.liveSearch = false;
        _this.liveSearchPlaceholder = null;
        _this.liveSearchStyle = 'contains';
        _this.maxOptions = 100;
        _this.isMobile = false;
        _this.tickIcon = 'zmdi-check';
        _this.open = false;
        return _this;
    }
    SelectPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onInit();
        this.query = new forms_1.FormControl();
        this.query.valueChanges.subscribe(function (filter) {
            _this._filterResults(filter);
        });
        this._updateValue();
    };
    SelectPickerComponent.prototype.ngOnChanges = function (changes) {
        var that = this;
        if (changes['items']) {
            var clone = [];
            var currentValue = changes['items'].currentValue;
            if (currentValue) {
                clone = currentValue.map(function (item) {
                    return {
                        id: item.id,
                        title: item.title,
                        disabled: item.disabled,
                        selected: item.selected,
                    };
                });
            }
            that._clonedItems = clone;
            this._updateSelectionText();
            if (this.initialized) {
                this._updateValue();
            }
            this._filterResults(null);
        }
    };
    Object.defineProperty(SelectPickerComponent.prototype, "emptySearch", {
        get: function () {
            return this.filteredItems === undefined || this.filteredItems.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    SelectPickerComponent.prototype.toggleOpen = function () {
        this.open = !this.open;
    };
    SelectPickerComponent.prototype.toggleItem = function (item) {
        if (!this.multiple) {
            this._clonedItems.forEach(function (item) {
                item.selected = false;
            });
            item.selected = !item.selected;
        }
        else {
            this._processMultipleSelection(item);
        }
        this._updateSelectionText();
        this._updateValue();
    };
    SelectPickerComponent.prototype.addValidators = function () { };
    SelectPickerComponent.prototype._updateValue = function () {
        var selectedItems = this._clonedItems
            .filter(function (item) { return item.selected; })
            .map(function (item) { return item.id; });
        var values = selectedItems.join(',');
        this.control.setValue(values);
        this.value = values;
    };
    SelectPickerComponent.prototype._updateSelectionText = function () {
        if (this._clonedItems) {
            this.selection = this._clonedItems
                .filter(function (item) { return item.selected; })
                .map(function (item) { return item.title; })
                .join(this.multipleSeparator);
        }
        if (!this.selection) {
            this.selection = this.noneSelectedText;
        }
    };
    SelectPickerComponent.prototype._filterResults = function (filter) {
        var contains = this.liveSearchStyle === 'contains';
        if (!filter || filter === '') {
            this.filteredItems = this._clonedItems;
        }
        else {
            this.filteredItems = this._clonedItems.filter(function (item) {
                return contains ?
                    item.title.toLowerCase().includes(filter.toLowerCase()) :
                    item.title.toLowerCase().startsWith(filter.toLowerCase());
            });
        }
    };
    SelectPickerComponent.prototype._processMultipleSelection = function (item) {
        var selectedItems = this._clonedItems.filter(function (item) {
            return item.selected;
        });
        if (!item.selected && selectedItems.length >= this.maxOptions) {
            return;
        }
        item.selected = !item.selected;
    };
    return SelectPickerComponent;
}(input_base_component_1.InputBase));
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], SelectPickerComponent.prototype, "fg", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "field", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SelectPickerComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "placeholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SelectPickerComponent.prototype, "alt", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "leftIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "rightIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], SelectPickerComponent.prototype, "items", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SelectPickerComponent.prototype, "multiple", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SelectPickerComponent.prototype, "autofocus", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "noneSelectedText", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "noneResultsText", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "multipleSeparator", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SelectPickerComponent.prototype, "liveSearch", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "liveSearchPlaceholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "liveSearchStyle", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], SelectPickerComponent.prototype, "maxOptions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SelectPickerComponent.prototype, "isMobile", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SelectPickerComponent.prototype, "tickIcon", void 0);
SelectPickerComponent = __decorate([
    core_1.Component({
        selector: 'select-picker',
        template: "\n      <div class=\"input-group m-b-15 w-100\" [class.fc-alt]=\"alt\" [ngClass]=\"{ 'has-error': !control.valid &amp;&amp; (fg.submitted || control.dirty)}\"><span class=\"input-group-addon\" *ngIf=\"leftIcon\"><i class=\"zmdi zmdi-{{leftIcon}}\"></i></span><div class=\"btn-group bootstrap-select\" [class.fc-alt]=\"alt\"><button class=\"btn dropdown-toggle btn-default\" type=\"button\" data-toggle=\"dropdown\" role=\"button\" title=\"{{selected}}\" aria-expanded=\"true\" (click)=\"toggleOpen()\"><span class=\"filter-option pull-left\">{{selection}}</span><span class=\"bs-caret\"><span class=\"caret\"></span></span></button><div class=\"dropdown-menu\" [class.open]=\"open\" role=\"combobox\" style=\"max-height: 394px; overflow: hidden; min-height: 0px\"><div class=\"bs-searchbox\" *ngIf=\"liveSearch\"><input class=\"form-control\" [formControl]=\"query\" type=\"text\" autocomplete=\"off\" role=\"textbox\" aria-label=\"Search\" placeholder=\"{{liveSearchPlaceholder}}\"></div><ul class=\"dropdown-menu inner\" role=\"listbox\" aria-expanded=\"true\" style=\"max-height: 392px; overflow-y: auto; min-height: 0px\"><li *ngFor=\"let item of filteredItems; let idx = index\" [attr.data-original-index]=\"idx\" [class.selected]=\"item.selected\" (click)=\"toggleItem(item)\"><a tabindex=\"{{idx}}\" [attr.data-tokens]=\"null\" role=\"option\" [attr.aria-disabled]=\"item.disabled\" [attr.aria-selected]=\"item.selected\"><span class=\"text\">{{item.title}}</span><span class=\"zmdi check-mark {{tickIcon}}\"></span></a></li><li class=\"no-results\" *ngIf=\"emptySearch\">{{ noneResultsText }} \"{{ query.valueChanges | async }}\"</li></ul></div><select class=\"my-selectpicker\" style=\"display: none\" tabindex=\"-98\" [class.mobile-device]=\"isMobile\" [attr.multiple]=\"multiple\"><option *ngFor=\"let item of filteredItems\" value=\"{{item.id}}\" [attr.selected]=\"item.selected ? true : null\">{{item.title}}</option></select></div><span class=\"input-group-addon last\" *ngIf=\"rightIcon\"><i class=\"zmdi zmdi-{{rightIcon}}\"></i></span></div>\n    ",
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], SelectPickerComponent);
exports.SelectPickerComponent = SelectPickerComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/forms/select-picker/select-picker.component.js
// module id = 63
// module chunks = 0